/**
 * Founder-only gate — centralised list of founder emails used
 * to gate internal-only features (PE KPIs, Performance tab, etc.).
 *
 * Reads VITE_FOUNDER_EMAILS at build time; falls back to the known
 * founder list so the gate works even before that env var is wired in CI.
 */
export const FOUNDER_EMAILS: readonly string[] = (
  (import.meta.env.VITE_FOUNDER_EMAILS as string | undefined) ??
  'nick@markperlbergcpa.com,nick@waypoint-intel.com,nick@waypoint-strategic-consulting.com,lucas@waypoint-intel.com,calladolucas@gmail.com'
)
  .split(',')
  .map((s) => s.trim().toLowerCase())
  .filter(Boolean);

export function isFounderEmail(email: string | undefined | null): boolean {
  return !!email && FOUNDER_EMAILS.includes(email.toLowerCase());
}
